<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      fill="currentColor"
      d="M17.2.8c-2.1 0-4 1-5.2 2.5-.6-.8-1.4-1.4-2.3-1.8C8.7 1 7.8.7 6.8.8 3 .8 0 3.7 0 7.5c0 3.4 1.9 6.5 4.1 9.1 2.2 2.6 4.9 4.8 7 6.4.3.2.6.3.9.3s.7-.1.9-.3c2-1.6 4.8-3.8 7-6.4C22.1 14 24 10.8 24 7.5c0-3.8-3-6.7-6.8-6.7z"
    />
  </svg>
</template>
